import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileCorporateTrainingsSectionTranslation = SectionTranslationModel<{
  competencyArea: string;
  form: {
    corporateTrainingsType: string;
    subtitle: string;
    title: string;
  };
  noTrainings: string;
  noTrainingsSelected: string;
  selected: string;
  skills: string;
}>;

export const employeeProfileCorporateTrainingsSectionTranslation: EmployeeProfileCorporateTrainingsSectionTranslation =
  {
    content: {
      competencyArea: 'Obszar kompetencyjny',
      form: {
        corporateTrainingsType: 'Szkolenia',
        subtitle:
          'Wybierz rekomendowane obszary szkoleniowe dla pracownika (na potrzeby Działu Szkoleń i Rozwoju)',
        title: 'Potrzeby szkoleniowe',
      },
      noTrainings: 'Brak wybranych szkoleń',
      noTrainingsSelected: 'Wybierz obszary szkoleniowe',
      selected: 'Wybrane',
      skills: 'Umiejętności',
    },
    headerTitle: 'Badanie potrzeb szkoleniowych',
    headerTitleShorter: 'Badanie potrzeb szkoleniowych',
  };
